let functions = require('./modules/functions');

require('./modules/common.less');
require('./blocks/grid.less');
require('./blocks/site-block.less');
require('./blocks/hoverzoom.less');
require('./blocks/btn-def.less');
require('./blocks/icon-field.less');
require('./blocks/styledbox.less');
require('./blocks/heart.less');
require('./blocks/textblock.less');
require('./blocks/personal-block/personal-block');
require('./blocks/mini-cart.less');
require('./blocks/mini-cart.js');
require('./blocks/header.less');
require('./blocks/city-data-block/city-data-block');
require('./blocks/simple-search-form.less');
require('./blocks/topmenu/topmenu');
require('./blocks/tile.less');
require('./blocks/footer/footer.less');
require('./blocks/bot-ico-link.less');
require('./blocks/bottom-menu.less');
require('./blocks/soc-square-btn.less');
require('./blocks/mobilemenu/mobilemenu');
require('./blocks/cities-list.less');
require('./blocks/cart-preview/cart-preview');
require('./blocks/breadcrumbs.less');
require('./blocks/height-limit/height-limit');
require('./blocks/tooltip/tooltip');
require('./blocks/form/form');
require('./blocks/product-card/popup-product-card');
require('./blocks/heart');
require('./blocks/up-button/up-button');

require('./blocks/impromptu/impromptu-auth');
require('./blocks/impromptu/impromptu-cities');
require('./blocks/styled-select/styled-select');
require('./blocks/reg-benefits.less');
require('./blocks/validator');
require('./blocks/drop-file/drop-file');

require('./blocks/special-action.less');
require('./blocks/impromptu/impromptu-reg-promo');
require('./blocks/callback/callback.js');

require('./blocks/social-in-pages.less');
require('./blocks/social-in-pages.js');

/* Для корректногй работы popup-карточки на любой странице */
require('./blocks/product-detail/product-detail');
//require('./blocks/product-card/product-card');
require('./blocks/impromptu/impromptu-add2cart');
require('./blocks/quantity/quantity.js');
require('./blocks/cart/cart.js');
/* Popup корзина необходима на любой странице */

require('./blocks/login-by-sms/login-by-sms');
require('./blocks/login-by-sms/login-by-sms.less');

require('./blocks/mobile-fixed-footer/mobile-fixed-footer.less');


import Trackers from './blocks/tracker/tracker';
import Mango from './calltracking/mango';
import Events from './blocks/tracker/events';

require('picturefill');
window.picturefill();

const trackers = new Trackers();
const events = new Events();
events.init();

jQuery(function($) {
    /*const mango = new Mango();
    mango.init();*/

    //это нужно чтобы на ай-осях клик срабатывал.
    //на боди кликаем когда хотим закрыть что-нибудь выпадающее
    if (functions.isIOS()) $('body').css('cursor', 'pointer');

    var $mainContainer = $('.main-container');
    $mainContainer.append('<div class="overlay" id="overlay" />');

    $('.js-scroll-link').click(function(e) {
        var $this = $(this);
        var target = this.hash;

        var $clickedTarget = $(e.target);

        if (!$this.is('a, button')) {
            if ($clickedTarget.is('a, button') || $clickedTarget.closest('a, button').length > 0) return;

            target = '#' + $this.data('href');
        }
        e.preventDefault();
        var $target = $(target);
        var top = $target.offset().top - 10;

        $('html, body')
            .stop()
            .animate(
                {
                    scrollTop: top
                },
                700,
                'swing',
                function() {
                    //window.location.hash = target;
                }
            );
    });

    $('.js-consult-button').click(function() {
        trackers.onAdviserWindow();
    });

    $('#carrotquest-messenger-reply-button').click(function() {
        trackers.onAdviserReply();
    });

    $(document).on('click', '#js-carrotquest-clicker', function() {
        //$('#carrotquest-messenger-collapsed').click();
        $('.b24-widget-button-wrapper').click();
    });

    /**
     *  Событие на отправку сообщение в чат bitrix 24
     *  Добавляем Google Client Id
     */
    window.addEventListener('onBitrixLiveChat', function(event) {
        // Проверяем корректность параметров события
        if (!event || !event.detail || !event.detail.widget) {
            return;
        }

        let widget = event.detail.widget;
        let ga = 'GoogleAnalyticsUserID=' + functions.getCookie('_ga');
        widget.setCustomData(ga);
    });

    window.addEventListener('b24:form:init', function (event) {
        let form = event.detail.object;

        form.setProperty('_ym_uid', functions.getCookie('_ym_uid'));
        form.setProperty("uf_lead_utm_campaign_hidden_form", functions.getCookie('utm_campaign'));
        form.setProperty("uf_lead_utm_medium_hidden_form", functions.getCookie('utm_medium'));
        form.setProperty("uf_lead_utm_source_hidden_form", functions.getCookie('utm_source'));
    });

    /**
     * Это обработчики отправки битриксовых форм, они нужны для отправки данных
     * с форм в сервис трекинга calltouch
     */
    /*window.addEventListener('b24:form:init', (event) => {
        let form = event.detail.object;
        setTimeout(function() {
            let forms = document.forms;
            let countForm = document.forms.length;
            for (let i = 0; i < countForm; i++) {
                let jqForm = $(forms[i]);
                if (jqForm.hasClass('jqiform')) {
                    continue;
                }

                if (jqForm.find('[class^="b24"]').length !== 0) {
                    jqForm.on('submit', function(e) {
                        e.preventDefault();
                        let data = $(e.target).serializeArray();
                        data.push({name: 'formId', value: form.identification.id});
                        let params = {
                            sessionId: window.ct('calltracking_params', 'a23hd404').sessionId,
                            requestUrl: window.location.href,
                            form: data
                        };
                        $.post(
                            '/ajax/action/widget_calltracking/calltouch/',
                            params,
                            function(data) {
                                console.log(data);
                            },
                            'json'
                        );
                    });
                }
            }
        }, 1000);
    });*/

    trackers.backendPageViewed();
    trackers.clientTimeSite();
});

// Полифилл для closest
(function() {
    if (!Element.prototype.closest) {
        Element.prototype.closest = function(css) {
            let node = this;
            while (node) {
                if (node.matches(css)) return node;
                else node = node.parentElement;
            }
            return null;
        };
    }
})();

(function(doc, win) {
    $(doc).ready(function() {
        const searchForm = document.querySelector('.simple-search-form form');
        if (!searchForm) {
            return;
        }

        searchForm.onsubmit = function() {
            trackers.onSearch({
                fbpixel: {
                    content_name: this.firstElementChild.value
                }
            });
        };

        trackers.onContentView({ fbpixel: win.location.pathname.split('/')[1] });
    });
})(document, window);

$('body').on('click', '.subscribe__form .follow-by-email-submit', function(e) {
    let email = $('.subscribe__form input[name="sf_EMAIL"]').val();
    var emailPattern = /^([a-z0-9_.-])+@[a-z0-9-]+\.([a-z]{2,4}\.)?[a-z]{2,4}$/i;

    if (emailPattern.test(email)) {
        $.ajax({
            type: 'POST',
            url: '/ajax/action/subscribe_form/subscribe/',
            data: {
                email: email
            },
            success: function(response) {
                if (response.message == 'ok') {
                    $('.subscribe__form .flex-row-email.block-email').html('Вы успешно подписаны!');
                    $('.subscribe__form .flex-row-email.block-email').addClass('success');
                    $('.block-email-fotter').css('display', 'none');
                    trackers.onSubscriptionDone();
                } else {
                    $('.subscribe__form .flex-row-email.block-email .subscribe-form__error').html(
                        response.message + '!'
                    );
                }
            },
            dataType: 'json'
        });
    }
});


// WEBPACK FOOTER //
// ./common.js